import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.273 1 1 2.273l1.667 1.666C1.31 5.381 1 7.845 1 12c0 8.75 1.375 10 11 10 3.692 0 6.17-.184 7.823-.904l1.907 1.907 1.273-1.273zM3.94 5.213c-.328.368-.611.929-.812 1.899C2.888 8.267 2.8 9.828 2.8 12s.089 3.734.328 4.889c.233 1.125.577 1.7.974 2.06.416.379 1.108.72 2.423.945 1.321.226 3.081.306 5.475.306s4.154-.08 5.476-.306a9 9 0 0 0 .938-.207L11.627 12.9H6v-1.8h3.827l-2.2-2.2H6V7.273z"
                    fill="currentColor"
                />
                <path
                    d="M22.29 18.472c.558-1.48.71-3.561.71-6.472 0-8.75-1.375-10-11-10-2.438 0-4.348.08-5.839.343l1.605 1.604C8.9 3.841 10.288 3.8 12 3.8c2.394 0 4.154.08 5.476.306 1.314.226 2.007.566 2.423.945.397.36.74.936.973 2.06.24 1.156.328 2.717.328 4.89 0 2.171-.088 3.733-.328 4.888l-.029.136z"
                    fill="currentColor"
                />
                <path d="M18 8.9H12.72l-1.8-1.8H18z" fill="currentColor" />
            </g>
        </svg>
    )
);
CardLinesCrossedOutlinedSize24Glyph.displayName = 'CardLinesCrossedOutlinedSize24Glyph';
